import {Component} from '@angular/core';
import {NavigationModel} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-settings',
    templateUrl: './settings.component.html'
})
export class ACAAdminSettingsComponent {

    public routes: NavigationModel[] = [
        {
            title: 'CAP configuration',
            link: 'cap-config'
        },
        {
            title: 'Site configuration',
            link: 'site-and-project-config'
        }
    ];
}
